<template>
  <div
    class="m-edition-section-content-subject m-edition-account-security"
    key="accountChangePassword"
  >
    <h2> {{ $t('mEditionAccountChangePassword.title') }} </h2>
    <form
      autocomplete="off"
      @submit.prevent="updateUser"
    >
      <div class="m-container-primary">
        <div class="row">
          <div class="column column-6">
            <AtomInputPrimary
              v-model="data.previous_password"
              :inputError="$v.data.previous_password.$error"
              :label="$t('mEditionAccountChangePassword.inputs.previous_password.label')"
              :message-error="messageErrorPreviousPassword"
              name="previous_password"
              reference="previous_password"
              type="password"
              @blur="$v.data.previous_password.$touch()"
            />
          </div>
        </div>
        <div class="row">
          <div class="column column-6">
            <AtomInputPrimary
              v-model="data.proposed_password"
              :inputError="$v.data.proposed_password.$error"
              :label="$t('mEditionAccountChangePassword.inputs.proposed_password.label')"
              :message-error="messageErrorProposedPassword"
              :message="$t('mEditionAccountChangePassword.inputs.proposed_password.message')"
              name="proposed_password"
              reference="proposed_password"
              type="password"
              @blur="$v.data.proposed_password.$touch()"
            />
          </div>
        </div>

        <div class="row">
          <div class="column column-6">
            <AtomInputPrimary
              v-model="data.confirm_password"
              :inputError="$v.data.confirm_password.$error"
              :label="$t('mEditionAccountChangePassword.inputs.confirm_password.label')"
              :message-error="messageErrorConfirmPassword"
              name="confirm_password"
              reference="confirm_password"
              type="password"
              @blur="$v.data.confirm_password.$touch()"
            />
          </div>
        </div>

        <div class="row">
          <span class="column column-10">
            <AtomButtonPrimary :button-primary="buttonPrimary"/>
          </span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { minLength, required, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAccountChangePassword',

  data () {
    return {
      buttonPrimary: {
        action: 'GUARDAR',
        class: 'a-button-billing-primary margin-top-small',
        sending: false,
        type: 'submit'
      },

      data: {
        access_token: '',
        confirm_password: '',
        previous_password: '',
        proposed_password: ''
      }
    }
  },

  validations: {
    data: {
      previous_password: {
        minLength: minLength(8),
        required
      },

      proposed_password: {
        valid: function (value) {
          const containsUppercase = /[A-Z]/.test(value)
          const containsLowercase = /[a-z]/.test(value)
          const containsNumber = /[0-9]/.test(value)
          return (containsUppercase && containsLowercase && containsNumber)
        },
        minLength: minLength(8),
        required
      },

      confirm_password: {
        sameAsPassword: sameAs('proposed_password'),
        required
      }
    }
  },

  computed: {
    messageErrorConfirmPassword () {
      return this.$validation.getValidationMessage('mEditionAccountChangePassword', this.$v.data.confirm_password, 'confirm_password')
    },

    messageErrorPreviousPassword () {
      return this.$validation.getValidationMessage('mEditionAccountChangePassword', this.$v.data.previous_password, 'previous_password')
    },

    messageErrorProposedPassword () {
      return this.$validation.getValidationMessage('mEditionAccountChangePassword', this.$v.data.proposed_password, 'proposed_password')
    }
  },

  created () {
    this.data.access_token = localStorage.getItem('access_token')
  },

  methods: {
    updateUser () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.create('usuario', 'createUsuarioChangePassword', this.data)
          .then(response => {
            console.log(response.data)
            this.$alerts.pushAlert('mEditionAccountChangePassword', 'updateChangePassword', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAccountChangePassword', 'updateChangePassword', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
